import { render, staticRenderFns } from "./LoanDetailsNotes.vue?vue&type=template&id=50a49743"
import script from "./LoanDetailsNotes.vue?vue&type=script&lang=js"
export * from "./LoanDetailsNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports